import { render, staticRenderFns } from "./Webhooks.vue?vue&type=template&id=ff0ecbd2&scoped=true&"
import script from "./Webhooks.vue?vue&type=script&lang=js&"
export * from "./Webhooks.vue?vue&type=script&lang=js&"
import style0 from "./Webhooks.vue?vue&type=style&index=0&id=ff0ecbd2&prod&lang=scss&"
import style1 from "./Webhooks.vue?vue&type=style&index=1&id=ff0ecbd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0ecbd2",
  null
  
)

export default component.exports